import { create } from 'zustand';

interface QuickAccessAIChatStore {
  initialData: any;
  setInitialData: (data: any) => void;
}

export const useQuickAccessAIChatStore = create<QuickAccessAIChatStore>(
  (set) => ({
    initialData: null,
    setInitialData: (data) => set({ initialData: data }),
  })
);
